(function() {
  angular.module('cfn').controller('seedCoreController', [
    '$scope',
    '$rootScope',
    'CoreREST',
    'Seed',
    '$http',
    '$timeout',
    '$log',
    '$dialog',
    '$injector',
    '$route',
    'FavoriteService',
    'i18nFilter',
    'farmnet.FeatureToggleService',
    function(
      $scope,
      $rootScope,
      CoreREST,
      Seed,
      $http,
      $timeout,
      $log,
      $dialog,
      $injector,
      $route,
      FavoriteService,
      i18nFilter,
      featureToggle
    ) {
      $scope.bartoSeedManagement = app.credentials.company.countryIsoCode === 'CHE';

      let mode = {
        name: 'seed',
        hasActive: true
      };

      let ctrl = this;

      ctrl.isSwissBartoUser = app.credentials.company.countryIsoCode === 'CHE';
      Seed.isSwissBartoUser = ctrl.isSwissBartoUser;

      ctrl.getEntityName = function() {
        try {
          return $scope.details.seed.name;
        } catch (e) {
          return '';
        }
      };

      ctrl.onInit = function(gridController) {
        gridController.setFilter('active', true, true);
      };

      let specialAdd = (mode.specialAdd = []);
      let ele = null;
      ele = {};
      ele.property = 'harvestTypes';
      ele.Property = 'HarvestTypes';
      ele.editable = true;
      specialAdd.push(ele);

      // validation engine
      let vgi = {};
      vgi['active'] = '1';
      vgi['number'] = '1';
      vgi['name'] = '1';
      vgi['cultureName'] = '1';
      vgi['sysSeed.firstApproval'] = '1';
      vgi['sysSeed.officialId'] = '1';
      vgi['abbrFruit'] = '1';
      vgi['category'] = '1';
      vgi['seedUnit'] = '2';
      vgi['seedsPerUnit'] = '2';
      vgi['seedStockyardDisplayUnit'] = '2';
      vgi['planSeedDate'] = '2';
      vgi['weight1000'] = '2';
      vgi['germinationCap'] = '2';
      vgi['seedStrenght'] = '2';
      vgi['sowingType'] = '2';
      vgi['fixationN'] = '2';
      vgi['netPrice'] = '2';
      vgi['costs'] = '2';
      vgi['harvestDate'] = '3';
      vgi['harvestUnit'] = '3';
      vgi['plannedResults'] = '3';
      vgi['harvestStockyardDisplayUnit'] = '3';
      vgi['harvestTypes'] = '3';
      mode.vgi = vgi;

      return coreCommonController(
        'seed',
        ctrl,
        mode,
        $scope,
        $rootScope,
        CoreREST,
        Seed,
        $http,
        $timeout,
        $log,
        $dialog,
        $injector,
        $route,
        FavoriteService,
        i18nFilter
      );
    }
  ]);
})();
